import React from 'react';
import styled from 'styled-components';

function Title({ firstLine, secondLine }) {
  return (
    <TitleContainer className='pb-4'>
      <TitleText className='font-weight-bolder'>
        {firstLine}
        <br />
        {secondLine}
      </TitleText>
    </TitleContainer>
  );
}

const TitleContainer = styled.div``;
const TitleText = styled.h1`
  line-height: 34px;
`;

export default Title;
